/**
 * Application configuration
 *
 * This file loads configuration from an external config.json file that can be modified
 * without rebuilding the application. This allows the same build to be deployed to
 * different environments by simply replacing the config.json file.
 */
const defaultConfig = {
    apiBaseUrl: 'http://localhost:3001/api',
    cognitoRegion: 'us-east-1',
    cognitoUserPoolId: 'us-east-1_example',
    cognitoAppClientId: 'example-client-id',
    environment: 'local'
};

let config = { ...defaultConfig };

const loadConfig = async () => {
    try {
        const response = await fetch('/config.json');
        if (!response.ok) {
            console.warn('Could not load /config.json, using default config.');
            return defaultConfig;
        }

        const loadedConfig = await response.json();
        console.log(`Loaded configuration for environment: ${loadedConfig.environment || 'unknown'}`);
        return { ...defaultConfig, ...loadedConfig };
    } catch (error) {
        console.warn('Error loading config.json:', error);
        return defaultConfig;
    }
};

export const getConfig = async () => {
    if (!config.isLoaded) {
        config = await loadConfig();
        config.isLoaded = true;
    }
    return config;
};

export default defaultConfig;